export type PlanPeriodOption = { label: string; value: string };

/** Períodos de uso disponíveis para um plano. */
export const daysOptions: PlanPeriodOption[] = [
    { label: "1 mês", value: "30" },
    { label: "2 meses", value: "60" },
    { label: "3 meses", value: "90" },
    { label: "4 meses", value: "120" },
    { label: "6 meses", value: "180" },
    { label: "12 meses", value: "365" },
];
